<template>
  <div class="liquor-list">
    <div class="inner">
      <div
        class="item"
        :style="index % 5 === 4 ? 'margin-right: 0': 'margin-right: 15px;'"
        v-for="(item, index) in list"
        :key="index"
        @click="goto('/liquor/detail/' + item.id)"
      >
        <div class="top">
          <img :src="util.getFirstImage(item.multimedia)" />
        </div>
        <div class="bottom">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiquorList",
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    goto(path) {
      this.$router.push(path);
    }
  }
};
</script>

<style lang="scss">
.liquor-list {
  width: 1100px;
  margin: 0 auto;
  .inner {
    width: 1100px;

    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    // align-content: space-between;
    .item {
      width: 208px;
      cursor: pointer;

      .top {
        width: 208px;
        height: 208px;
        background: rgba(250, 250, 250, 1);
        text-align: center;
        line-height: 208px;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          // width: 208px;
          height: 180px;
        }
      }

      .bottom {
        margin: 15px 0 30px 0;
        width: 208px;
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(59, 41, 9, 1);
        line-height: 20px;

        overflow: hidden;
      }
    }
  }
}
</style>